package com.eladfinish.bible.contest.platform.haptics

import kotlinx.browser.window

/**
 * Vibrates through the Vibration API where the browser has one (Chrome and Firefox on Android).
 * Desktop browsers and Safari don't, and there this does nothing — as on a device with no vibrator.
 */
class WebHapticFeedback : HapticFeedback {
    override fun vibrate(milliseconds: Long) {
        vibrateIfSupported(milliseconds.toInt())
    }
}

internal fun vibrateIfSupported(milliseconds: Int) {
    val navigator = window.navigator.asDynamic()
    if (navigator.vibrate == null) return
    try {
        // Browsers ignore this until the user has interacted with the page.
        navigator.vibrate(milliseconds)
    } catch (_: Throwable) {
    }
}
